/* NB-019-AB */
document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('.quick-verdict-snapshot--var-1');
  if (!root) return;

  const pushEvent = (eventName, extra) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName, task: 'NB-019-AB' }, extra || {}));
  };

  const verdict = root.querySelector('[data-qvs-verdict]');
  if (verdict && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          pushEvent('nb019_verdict_visible');
          observer.disconnect();
        });
      },
      { threshold: 0.5 }
    );
    observer.observe(verdict);
  }

  const cta = root.querySelector('[data-qvs-cta]');
  if (cta) {
    cta.addEventListener('click', () => {
      pushEvent('nb019_verdict_cta_click');
    });
  }

  const more = root.querySelector('[data-qvs-more]');
  if (more) {
    more.addEventListener('click', (event) => {
      const href = more.getAttribute('href') || '#wins-comparison';
      const hashIndex = href.lastIndexOf('#');
      const id = hashIndex >= 0 ? href.slice(hashIndex + 1) : 'wins-comparison';
      const target = (id && document.getElementById(id)) || document.querySelector('.neubrain-wins-comparison');
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
});
